import { Stack } from '@mui/material';
import { useGetNotifications } from '@shared/notifications/model/useGetNotifications';
export function AppNotifications() {
  const notifications = useGetNotifications();
  return <Stack gap={2} sx={{
    position: 'fixed',
    bottom: 0,
    right: 0,
    padding: '20px',
    maxWidth: '400px',
    maxHeight: '400px',
    overflow: 'hidden',
    zIndex: 1301
  }} direction="column-reverse" justifyContent="flex-start" alignItems="flex-end">
      {notifications}
    </Stack>;
}